<template>
    <b-card v-if="data" class="earnings-card">
      <b-row>
        <b-col cols="12" >
            <b-card-title class="mb-1">
                    <img src = "@/assets/icons/trash-can-outline-svgrepo-com.svg"  width="30"  class="my-svg-alternatex"  alt=""/>
                    {{$t('Container Dump')}}
            </b-card-title>

         <div class="font-small-2 mt-1">
           <feather-icon
              icon="CircleIcon"
              size="16"
              class="text-primary"
            />
            {{$t('Planned')}}:  {{data.Planned}}
          </div>
  
           <div class="font-small-2  mt-1">
             <feather-icon
              icon="CircleIcon"
              size="16"
              class="text-primary"
            />
            {{$t('Served')}}:  {{data.Served}}
          </div>

          <b-progress  
              animated 
              striped 
              show-progress 
              label="Served"  
              :value="data.completion == undefined ? 0 : data.completion"
              max="100" 
              height="12px" 
              class="mt-2"
          />
            
        </b-col>

      </br>

      </b-row>

      <b-row>
        <b-col cols="12" >
            <contracts-chart
                :barSeries="data.Contracts.series" 
                :listData="data.Contracts.lists"
                :labels_data="data.Contracts.categories"
            />
        </b-col>
      </b-row>
    </b-card>
  </template>
  
  <script>
  
  
  import {
    BCard, 
    BRow, 
    BCol, 
    BCardTitle, 
    BCardText,
    BProgress
  } from 'bootstrap-vue'
  import VueApexCharts from 'vue-apexcharts'
  import { $themeColors } from '@themeConfig'

  import { ref } from '@vue/composition-api'

  import ContractsChart from './contractsChart.vue'
  
  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BCardTitle,
      BCardText,
      BProgress,
      VueApexCharts,
      ContractsChart
    },
    props:{
      data: {
        type: Object,
        default: () => {

        },
      }
    },
    setup(props, { root }) {

        const chartOptions = {
            chart: {
              type: 'donut',
              toolbar: {
                show: false,
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: { show: false },
            comparedResult: [2, -3, 8],
            labels: [root.$i18n.t('Served'), root.$i18n.t('Not Served')],
            stroke: { width: 0 },
             colors: [$themeColors.primary, $themeColors.warning, $themeColors.danger],
            grid: {
              padding: {
                right: -20,
                bottom: -8,
                left: -20,
              },
            },
            plotOptions: {
              pie: {
                //startAngle: -10,
                donut: {
                  labels: {
                    show: true,
                    name: {
                      offsetY: 15,
                    },
                    value: {
                      offsetY: -15,
                      formatter(val) {
                        return `${parseInt(val)}%`
                      },
                    },
                    total: {
                      show: true,
                      offsetY: 15,
                      label: root.$i18n.t('Served'),
                      formatter(w) {
                        return `${ w.globals.seriesTotals[0]}%`;
                      },
                    },
                  },
                },
              },
            },
            responsive: [
              {
                breakpoint: 1325,
                options: {
                  chart: {
                    height: 100,
                  },
                },
              },
              {
                breakpoint: 1200,
                options: {
                  chart: {
                    height: 120,
                  },
                },
              },
              {
                breakpoint: 1045,
                options: {
                  chart: {
                    height: 100,
                  },
                },
              },
              {
                breakpoint: 992,
                options: {
                  chart: {
                    height: 120,
                  },
                },
              },
            ],
          }

        return {
            chartOptions
        }

    }
}
  </script>
  